import { render } from "./StorageModal.vue?vue&type=template&id=3133efb9&scoped=true"
import script from "./StorageModal.vue?vue&type=script&lang=js"
export * from "./StorageModal.vue?vue&type=script&lang=js"

import "./StorageModal.vue?vue&type=style&index=0&id=3133efb9&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3133efb9"]])

export default __exports__